import React from 'react';
import config from '@config';
import { BOTTOM_INDENTS, COLORS, defaultTimeProps, TOP_INDENTS } from '@constants';
import { Button, Divider, Icon, Tag, Typography } from '@ui';
import { Card, Flex, Row } from 'antd';
import SetupWizard from '../../../../components/SetupWizard';
import { LogoConnector } from '../../../../ui/LogoConnector';
import CheckboxCard from '../../../Performance/components/Overview/components/CheckboxCard';
import CheckboxCardsPlaceholder from '../../../Performance/components/Overview/components/CheckboxCardsPlaceholder';
import { StyledFlex, StyledWrapper } from '../../styled';

const Connected = ({
    handleSetupDone,
    showModalSetup,
    pendingMetricsOverview,
    shopDomain,
    performanceList,
    isShopify,
    firstName,
    lastName
}) => {
    const date = defaultTimeProps;

    return (
        <StyledWrapper>
            {showModalSetup && isShopify ? <SetupWizard onDone={handleSetupDone} /> : null}
            <StyledFlex align='center' justify='space-between'>
                <LogoConnector />
                {isShopify ? null : (
                    <Typography.Title level={2}>
                        {`Welcome${
                            firstName || lastName ? `, ${[firstName, lastName].filter(Boolean).join(' ')}` : ''
                        }`}
                    </Typography.Title>
                )}
                <Button
                    style={{ width: 160 }}
                    type='primary'
                    onClick={() => {
                        const win = window.open(config.appUrl + '/home', '_blank', 'noopener,noreferrer');
                        if (win) win.opener = null;
                    }}
                >
                    Visit Klickly
                </Button>
            </StyledFlex>
            <Divider margin={0} />
            <Card style={{ ...TOP_INDENTS.XL_PLUS, ...BOTTOM_INDENTS.XL_PLUS }}>
                <Flex align='center' justify='space-between' gap={16}>
                    <Flex gap={16} align='center'>
                        <Icon color={COLORS.$gray60Black} size='80px' component={() => <Icon.CampaignIcon />} />
                        <Flex vertical>
                            <Typography.Text marginBottom='8px' type='badgeLarge'>
                                App connection status
                            </Typography.Text>
                            <Typography.Text color={COLORS.$gray60Black} type='body2'>
                                Your Klickly Brands advertising connection is ready. All necessary information will
                                automatically be updated from now on.
                            </Typography.Text>
                        </Flex>
                    </Flex>
                    <Tag color={COLORS.$robinBlue}>
                        <Typography.Text type='badgeSmall' color={COLORS.$white}>
                            {shopDomain ? `Connected to ${shopDomain}` : 'Connected'}
                        </Typography.Text>
                    </Tag>
                </Flex>
            </Card>
            <Typography.Title level={2} style={BOTTOM_INDENTS.L}>
                Performance overview (last 30 days)
            </Typography.Title>
            <Row gutter={[16, 16]}>
                {pendingMetricsOverview ? (
                    <CheckboxCardsPlaceholder />
                ) : (
                    performanceList?.map((metric) => {
                        return <CheckboxCard key={metric.id} date={date} metric={metric} hideInfo />;
                    })
                )}
            </Row>
        </StyledWrapper>
    );
};

export default Connected;
